import TableCell from "@mui/material/TableCell";
import Skeleton from "@mui/material/Skeleton";
import TableRow from "@mui/material/TableRow";

const RenderLoading = () => {
  return [...Array(10)].map((_, index) => (
    <TableRow key={`skeleton-${index}`} sx={{ height: "56px" }}>
      <TableCell>
        <Skeleton variant="rectangular" />
      </TableCell>
      <TableCell>
        <Skeleton variant="rectangular" />
      </TableCell>
      <TableCell>
        <Skeleton variant="rectangular" />
      </TableCell>
    </TableRow>
  ));
};

export default RenderLoading;
